import styled from 'styled-components';
import { ClipboardCopy } from 'components/common/ClipboardCopy/ClipboardCopy';
import { CopyIcoOutline } from 'components/common/ClipboardCopy/ClipboardCopy.styles';
import { Icon } from 'components/uikit/Icon/Icon';
import { Container } from 'components/uikit/Tooltip/Tooltip.styles';

export const Card = styled.div`
  display: grid;
  grid-template-columns: 32px 1fr;
  color: var(--color-white);
  gap: 8px;
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  > div:first-child {
    margin-bottom: -6px;
  }
`;

export const StyledIco = styled(Icon)`
  width: 32px;
  height: 32px;
  border-radius: 16px;
  margin-top: 2px;
  background-color: var(--color-grey-7);
`;

export const Title = styled.div`
  font: var(--font-large-15);
`;

export const Subtitle = styled.div`
  color: var(--color-white_68);
  margin-bottom: 4px;
  font: var(--font-regular-13);
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  font: var(--font-regular-13);
`;

export const Label = styled.div`
  color: var(--color-white_68);
`;

export const DataValue = styled.div`
  display: flex;
  align-items: center;
`;

export const ClipboardCopyStyled = styled(ClipboardCopy)`
  ${CopyIcoOutline} {
    --color: var(--color-white_68);
    &:hover {
      --color: var(--color-white);
    }
  }
  ${Container} {
    border-radius: 6px;
    padding: 4px 8px;
    background-color: var(--color-green-5);
    color: var(--color-green-2);
    font: var(--font-regular-11);
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 4px;

  & > * {
    flex-grow: 1;
  }
`;

export const StyledImg = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 16px;
  margin-top: 2px;
  background-color: var(--color-grey-7);
`;
